import { render, staticRenderFns } from "./publishTenderAnnouncement.vue?vue&type=template&id=0ac134fc"
import script from "./publishTenderAnnouncement.vue?vue&type=script&lang=js"
export * from "./publishTenderAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./publishTenderAnnouncement.vue?vue&type=style&index=0&id=0ac134fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports